import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';
import {
    Calendar,
    Category,
    BarChart
} from './components';
import {getCategory} from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    }
}));

const Error = () => (<div>Error</div>);

const Frequency = () => {
    const classes = useStyles();
    // const [options, setOptions] = React.useState({});
    const TERM = 'monthly';
    const getStandardDate = () => {
        const standard_date = new Date();
        standard_date.setMonth(standard_date.getMonth() - 1);

        return standard_date;
    };
    const getComparisonDate = () => {
        const comparison_date = new Date();
        comparison_date.setMonth(comparison_date.getMonth() - 2);

        return comparison_date;
    };

    // 카테고리 선택
    const [category, setCategory] = React.useState({});
    const changeCategory = (cate = {}) => {
        setCategory(cate);
    };

    // 대카테고리 리스트 가져오기
    const [categoryList, setCategoryList] = React.useState([]);
    if (categoryList.length === 0) {
        getCategory()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setCategoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const onSubmit = ({targetDate, compareDate}) => {
        // const {parentCode: category1, code: category2} = category;
        const {parentCode: category1} = category;

        if (category1 && targetDate && compareDate) {
            // setOptions({
            //     category1,
            //     ...(category2 !== '' ? {category2} : {}),
            //     targetDate,
            //     compareDate
            // });
        }
    };
    const errorHandler = () => <Error/>;

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <Category
                        categoryList={categoryList}
                        changeCategory={changeCategory}
                    />
                </Grid>
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <Calendar
                        comparison_date_option={{
                            format: 'yyyy/MM',
                            label: 'comparison month',
                            openTo: 'year',
                            views: ['year', 'month'],
                            date: getComparisonDate(),
                        }}
                        start_date_option={{
                            format: 'yyyy/MM',
                            label: 'reference month',
                            openTo: 'year',
                            views: ['year', 'month'],
                            date: getStandardDate()
                        }}
                        term={TERM}
                        onSubmit={onSubmit}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xs={12}
                >
                    <BarChart/>
                </Grid>
            </Grid>
        </div>
    );
};

export default Frequency;
